<div class="w-100 d-flex flex-wrap surface-elevent">
  <ngx-app-bar
    class="w-100"
    [title]="'به زودی'"
    [rightButton]="{
      icon: 'arrow-right',
      style: 'neutral-link',
      mode: 'icon-only',
      size: 'medium',
    }"
    (onRightButtonClick)="onBackHandler()"
  />

  <div class="w-100 d-flex flex-wrap px-plus">
    <div class="w-100 d-flex flex-wrap justify-content-center align-items-center align-content-center coming-soon-container">
      <img
        src="wealth-assets/icons/coming-soon.svg"
        alt="coming-soon"
      />
      <p class="w-100 text-align-center b-2 text-onback-medium px-minus">به ‌زودی می‌توانید از این قسمت {{ comingSoon() }} انجام دهید.</p>
    </div>

    <div class="w-100 d-flex mt-big">
      <ngx-button
        [style]="'fill'"
        (clickHandler)="onBackHandler()"
        [className]="'detail-button'"
        [fullWidth]="true"
        [destructive]="false"
        [buttonId]="'COMING_SOON_CONFIRM'"
        size="medium"
      >
        متوجه شدم
      </ngx-button>
    </div>
  </div>
</div>
